module.exports = __webpack_public_path__ + "img/1F1EA-1F1F8.49ad7e59.svg";